import { CONTACT_FIELDS_DEFAULTS, pickContactFields } from '@features/ContactFieldsSettings';
import { LOCATION_TYPE } from '@features/ComboLocationSelect';
import { FORM_TEXT_FIELDS } from '@constants/forms';
import { isSurveyTextComplete } from '@helpers/surveyLanguages';

export const buildFormDefaults = ({ language, confirmationMessage }) => ({
    internalName: '',
    locationType: LOCATION_TYPE.LOCATION,
    locationId: '',
    brandId: '',
    brandAccess: true,
    valuesAlreadySetToForm: false,
    texts: [{ language, title: '', description: '', confirmationMessage }],
    labels: [],
    ...CONTACT_FIELDS_DEFAULTS,
});

export const areTextsComplete = texts =>
    texts?.length > 0 && texts.every(text => isSurveyTextComplete(text, FORM_TEXT_FIELDS));

export const toFormModel = (form, values) => {
    const isBrand = values.locationType === LOCATION_TYPE.BRAND;
    return {
        id: form?.id,
        internalName: values.internalName,
        locationId: !isBrand && values.locationId ? Number(values.locationId) : null,
        brandId: isBrand && values.brandId ? values.brandId : null,
        texts: values.texts,
        labels: values.labels,
        ...pickContactFields(values),
    };
};

export const getFormPublicUrl = formId => `${import.meta.env.REACT_APP_SURVEY_DOMAIN}/f/${formId}`;

export const toSubmissionsFileName = internalName => {
    const safeName = (internalName || '').replace(/[\\/:*?"<>|]/g, '-').trim();
    return `${safeName || 'form-submissions'}.csv`;
};
